import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuthState } from '../../../js/firebase';
import Loader from '../Loader/Loader';
import Box from '@mui/material/Box';

const AdminRoute = ({ component: C, ...props }) => {
    const { user, isAuthenticated, userRole, loadingRole } = useAuthState();

    if (!isAuthenticated) {
        return <Redirect to="/login" />;
    }

    if (loadingRole) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <Loader />
            </Box>
        );
    }

    if (userRole === 'admin') {
        return <Route {...props} render={routeProps => <C {...routeProps} />} />;
    }

    // User is authenticated but not admin - redirect to home
    return <Redirect to="/" />;
};

export default AdminRoute;

